import React from "react";
import { Box, Typography, CardContent, useTheme } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { StyledCard } from "../../common/StyledCard";
import { formatCurrency } from "../../../utils/currencyUtils";
import { ExpenseBreakdownBiDto } from "../../../shared/dtos/bi/ExpenseBreakdownBiDto";

interface ExpenseBreakdownWidgetProps {
  data?: ExpenseBreakdownBiDto[];
}

const COLORS = ["#f44336", "#e91e63", "#9c27b0", "#ff9800", "#ff5722"];

const ExpenseBreakdownWidget: React.FC<ExpenseBreakdownWidgetProps> = ({
  data = [],
}) => {
  const theme = useTheme();

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 3 }}>
          Expense Breakdown
        </Typography>

        {data.length > 0 ? (
          <Box sx={{ flexGrow: 1, width: "100%", minHeight: 300 }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={70}
                  outerRadius={100}
                  paddingAngle={3}
                  dataKey="totalAmount"
                  nameKey="categoryName"
                >
                  {data.map((_, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    borderRadius: 8,
                    borderColor: theme.palette.divider,
                  }}
                  formatter={(value, name, props) => [
                    `${formatCurrency(Number(value))} (${props.payload.expenseCount} entries)`,
                    name,
                  ]}
                />
                <Legend verticalAlign="bottom" height={36} iconType="circle" />
              </PieChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              minHeight: 300,
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              No expense data available.
            </Typography>
          </Box>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default ExpenseBreakdownWidget;
